export default __webpack_public_path__ + "static/media/monitor-tv.93e9c823.svg";